module.exports = __webpack_public_path__ + "img/2.c049fb77.png";